import {Component, OnInit, inject, signal, ChangeDetectionStrategy} from '@angular/core';
import {CommonModule} from '@angular/common';
import {VwuiAngularModule, VwuiModalConfig, VwuiModalRef} from '@bvgo-ict/vwui-angular';

import {ProjectVersionService} from '../../services';
import {IProjectVersionData} from '../../models/project/project-data';
import {TranslatePipe} from "@ngx-translate/core";

export interface ProjectVersionsListModalData {
    projectId: number;
}

@Component({
    selector: 'app-project-versions-list-modal',
    templateUrl: './project-versions-list-modal.component.html',
    styleUrls: ['./project-versions-list-modal.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, TranslatePipe, VwuiAngularModule]
})
export class ProjectVersionsListModalComponent implements OnInit {
    public readonly modalRef = inject(VwuiModalRef);
    public readonly modalConfig = inject<VwuiModalConfig<ProjectVersionsListModalData>>(VwuiModalConfig);
    private readonly projectVersionService = inject(ProjectVersionService);

    public readonly versions = signal<IProjectVersionData[]>([]);
    public readonly isLoading = signal(true);

    ngOnInit(): void {
        const {projectId} = this.modalConfig.data;
        this.projectVersionService.list(projectId).subscribe({
            next: (versions) => {
                this.versions.set(versions);
                this.isLoading.set(false);
            },
            error: () => {
                this.versions.set([]);
                this.isLoading.set(false);
            }
        });
    }

    public download(version: IProjectVersionData): void {
        this.projectVersionService.downloadPdf(version).subscribe();
    }

    /**
     * Display the reason why there is no attachment.
     */
    public noAttachmentReason(version: IProjectVersionData): string {
        if ('PROCESSING' === version.status) {
            return 'PROJECT_VERSIONS_LIST.modal.status.processing';
        }

        return 'PROJECT_VERSIONS_LIST.modal.status.failed';
    }

    public trackVersion(_index: number, version: IProjectVersionData): string {
        return `${version.majorVersion}.${version.minorVersion}`;
    }
}
